<a3l-ui-dialog-header>
  <h2 translate>Informacje o wyborze języka</h2>
</a3l-ui-dialog-header>
<a3l-ui-dialog-content>
  <p translate>Te informacje tłumaczą sie automatycznie po zapisaniu</p>
</a3l-ui-dialog-content>
<a3l-ui-dialog-footer class="text-center">
  <button type="button" a3l-ui-button color="primary" (click)="close()" translate>Rozumiem</button>
</a3l-ui-dialog-footer>
